import type { StyleRule } from '@archipro-design/aria';
import {
    bannerAdTileSlotClassNames,
    buttonClassName,
    imageOverlayClassName,
    labelClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const Container: StyleRule<{ columns: number }> = ({
    theme,
    columns,
}) => {
    return {
        gridColumn: `1/${columns + 1}`,
        padding:
            columns <= 2
                ? pxArrayToRem([0, 16, 0, 16])
                : pxArrayToRem([0, 18, 0, 18]),
        '> div > :nth-child(n + 2)': {
            paddingLeft: undefined,
        },
        [`& .${imageOverlayClassName}`]: {
            background: 'transparent',
            '&:hover': {
                opacity: 0,
            },
        },
        [`& p.${bannerAdTileSlotClassNames.title}`]: {
            color: theme.siteVariables.colors.charcoal['350'],
            lineHeight: pxToRem(29),
        },
        [theme.screen.min.tablet]: {
            padding: pxArrayToRem([0, 12, 0, 12]),
            '> div > :nth-child(n + 2)': {
                paddingLeft: 'unset',
            },
            [`& p.${bannerAdTileSlotClassNames.title}`]: {
                lineHeight: pxToRem(39),
            },
        },
    };
};

export const CTAButton: StyleRule = ({ theme }) => ({
    [`&.${buttonClassName}`]: {
        background: theme.siteVariables.colors.charcoal['250'],
        width: 'fit-content',
        marginTop: pxToRem(44),
        border: 'none',
        padding: pxArrayToRem([15, 23]),

        [`& .${svgIconClassName}`]: {
            width: pxToRem(13),
            height: pxToRem(13),
        },
        [`& .${labelClassName}`]: {
            fontSize: pxToRem(14),
            textTransform: 'uppercase',
        },
        [theme.screen.min.tablet]: {
            marginTop: 'unset',
            padding: pxArrayToRem([20, 22]),
            [`& .${svgIconClassName}`]: {
                width: pxToRem(24),
                height: pxToRem(24),
            },
            [`& .${labelClassName}`]: {
                fontSize: pxToRem(24),
                lineHeight: theme.siteVariables.lineHeightSmallest,
            },
        },
    },
});
